import { Box } from '@mui/material';
const GridEmptyLine = () => {
  return <Box width='100%' />;
};

export default GridEmptyLine;
